import { IVessel, ISar, IAton, IBaseStation } from "./models";

export default class TargetsState {
  vessels: IVessel[] = [];
  sars: ISar[] = [];
  atons: IAton[] = [];
  baseStations: IBaseStation[] = [];
  selectedVessel: number = 0;
  selectedSar: number = 0;
  predictionTime:number = 3;
  targetsTag:boolean = false;
}
